import gql from 'graphql-tag';

export const DELETE_TERRITORY_GROUP = gql`
  mutation DeleteTerritoryGroup($territoryGroupId: Int) {
    deleteTerritoryGroup(territoryGroupId: $territoryGroupId) {
      territoryGroupId
    }
  }
`;
